<svelte:head>
  <title>Email templates | A Good Thing</title>
</svelte:head>

<nav class="level">
  <!-- Left side -->
  <div class="level-left">
    <div class="level-item">
      <h2 class="title">Email templates</h2>
    </div>
  </div>

  <!-- Right side -->
  <div class="level-right"><a class="button" href={$url('/admin/email_template/create')}>Create</a></div>
</nav>

<table class="table is-fullwidth is-hoverable">
  <thead>
    <tr>
      <th style="">ID</th>
      <th style="width:100%;">Subject</th>
      <th />
    </tr>
  </thead>
  <tbody>
    {#each items as item}
      <tr>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center"
            style="height:60px;">
            <a href={$url('../../email_template/view/' + item.id)}>{item.id}</a>
          </div>
        </td>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center"
            style="height:60px;">
            {item.data.subject || '(No subject)'}
          </div>
        </td>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center"
            style="height:60px;">
            <!-- svelte-ignore a11y-missing-attribute -->
            <a on:click={() => {
              $uiState.activeModal = { component: ConfirmDelete, props: { item } };
            }}>Delete</a>
          </div>
        </td>
      </tr>
    {/each}
  </tbody>
</table>

<script lang="ts">
  import _ from "lodash";
  import ConfirmDelete from "./_components/ConfirmDelete.svelte";
  import { url } from "@sveltech/routify";
  import { uiState } from "../../../../lib/uiState";

  //let data = _.cloneDeep($appState.company);

  let items :any[] = [];

  let firebase = window.firebase;

  get();

  async function get() {
    firebase
      .firestore()
      .collection("_mail_templates")
      .onSnapshot((docs) => {
        let _items: any[] = [];

        docs.forEach((doc) => {
          _items.push({ id: doc.id, data: doc.data() });
        });

        items = _items;
      });
  }
</script>
